import { createFileRoute, redirect } from '@tanstack/react-router';

import { hrefBelow, type PageStaticData } from '@/shared/routing';

// Moved to `/manufacturing/resources/...`; old bookmarks and links still land here.
export const Route = createFileRoute('/_authenticated/manufacturing/resource/$')({
    // Only redirects: the target checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    // No `validateSearch`, like the other splats: the target's validator reads the query string.
    beforeLoad: ({ params, location }) => {
        throw redirect({
            href: hrefBelow('/manufacturing/resources', params._splat, location.searchStr),
            replace: true,
        });
    },
});
